import assertString from "./util/assertString";
import isInt from "./isInt";

var maxYear = (new Date()).getFullYear();
var minYear = maxYear - 110;
export default function isBirthYear(int) {
    return isInt(int, {
        min: minYear,
        max: maxYear
    });
}